import './assets/main.css'

import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createPinia } from 'pinia'
import App from './App.vue'
import { checkAuth } from './utils/auth'

// Create router instance
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./components/MainView.vue')
    }
  ]
})

// Create Pinia instance
const pinia = createPinia()

// Check authentication before rendering the app
checkAuth().then(isAuthenticated => {
  if (isAuthenticated) {
    // Create and mount the app
    const app = createApp(App)
    app.use(router)
    app.use(pinia)
    app.mount('#app')
  }
})
